import { Trans, useTranslation } from "react-i18next";
import { useEffect } from "react";
import styles from "../../css/style.module.css";
import CSFDSSection1 from "../platform/CSFDS_Section_1";
import Device200240 from "../device/200240";

function PublicMain({makeHeader}) {

	const Header = makeHeader();
	const { t, i18n } = useTranslation()
	useEffect(() => {
		document.title = t("쿨차지충전기 공공조달");
	},[t])

	return (
		<div className={styles.device}>
			<section className={styles.main_visual}>
				{Header}

				<div className={[styles.main_bg_extended, styles.main_bg].join(" ")}></div>

				<h2 className={styles.h2}>
					<div>{t("공공조달")}</div>
					{i18n.language !== "en" && <div>Public Conveyance</div>}
				</h2>

				<div className={styles.scroll_downs}>
					<div className={styles.mousey}>
						<div className={styles.scroller}></div>
					</div>
				</div>

				<div className={styles.subnav_btn}>
					<div><a href="#KCA7">GKCA7</a></div>
					<div><a href="#KCD50100">GKCD<br/>50/100</a></div>
					<div><a href="#KCD200240">GKCD<br/>200/240</a></div>
				</div>
			</section>

			<section className={styles.main_container}>
				<h3 className={styles.h3} data-aos="fade-up" data-aos-anchor-placement="top-center">
					<div>{t("독보적 AI 기술로 더욱 스마트한")}</div>
					<Trans t={t} i18nKey={"EV 충전 솔루션 <1>쿨차지</1>"} components={{ 1: <span/> }}>
						EV 충전 솔루션 <span>쿨차지</span>
					</Trans>
				</h3>

				<div className={styles.charger} data-aos="fade-up">
					<div>
						<div className={styles.charger_txt_wrap}>
							<div className={styles.charger_txt} data-aos="fade-down">
								<ul>
									<li>
										01
									</li>

									<li>
										{t("나를 알아보는 충전기")}, <span>{t("쿨차지")}</span>
									</li>

									<li>
										{t("충전기 전면의 고해상도 카메라와 AI기반 분석기술로 내 차 번호판, 내 얼굴을 인식하는똑똑한 충전기")}
									</li>
								</ul>
							</div>

							<div className={styles.charger_txt} data-aos="fade-down" data-aos-delay="400">
								<ul>
									<li>
										02
									</li>

									<li>
										{t("내 차를 지켜주는 충전기")}, <span>{t("쿨차지")}</span>
									</li>

									<li>
										{t("충전기에 탑재 된 지능형 CCTV가 충전 중 발생하는 돌발 상황을 감지하고 녹화해서 사고, 화재를 감시")}
									</li>
								</ul>
							</div>

							<div className={styles.charger_txt} data-aos="fade-down" data-aos-delay="800">
								<ul>
									<li>
										03
									</li>

									<li>
										{t("동급최강의 탁월한 편의성")}, <span>{t("쿨차지")}</span>
									</li>

									<li>
										<span className={styles.txt_span}>▪</span> {t("QR코드 및 NFC기반의 간편결제 연동")}
									</li>

									<li>
										<span className={styles.txt_span}>▪</span> {t("콤팩트한 본체와 저발열 설계")}
									</li>

									<li>
										<span className={styles.txt_span}>▪</span> {t("전면 개폐 구조로 간편한 A/S")}
									</li>

									<li>
										<span className={styles.txt_span}>▪</span> {t("쿨차지 전용 모바일앱으로 손쉬운 서비스 업데이트")}
									</li>
								</ul>
							</div>
						</div>
						<div className={styles.charger_table} data-aos="fade-down">
							<div>
								<table>
									<thead>
										<tr>
											<th>조달식별번호</th>
											<th>모델명</th>
											<th>물품가</th>
											<th>충전용량</th>
											<th>특징</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>25613486</td>
											<td>GKCAN7PG-L5G</td>
											<td>2,850,000원</td>
											<td>7kW</td>
											<td>IP65</td>
										</tr>
										<tr>
											<td>25647311</td>
											<td>GKCAP7PG-L5G</td>
											<td>3,900,000원</td>
											<td>7kW</td>
											<td>IP65, PLC</td>
										</tr>
										<tr>
											<td>25647310</td>
											<td>GKCAP7PG-CL5G</td>
											<td>4,100,000원</td>
											<td>7kW</td>
											<td>IP65, PLC, 카메라장착</td>
										</tr>
										<tr>
											<td>25528776</td>
											<td>GKCD50PS-C27L5G</td>
											<td>19,300,000원</td>
											<td>50kW</td>
											<td>1채널</td>
										</tr>
										<tr>
											<td>25528777</td>
											<td>GKCD50P-C27L5G</td>
											<td>20,000,000원</td>
											<td>50kW</td>
											<td>2채널</td>
										</tr>
										<tr>
											<td>26095056</td>
											<td>GKCD50PS-G2-H27MWC</td>
											<td>18,800,000원</td>
											<td>50kw</td>
											<td>1채널</td>
										</tr>
										<tr>
											<td>26095052</td>
											<td>GKCD50P-G2-H27MWC</td>
											<td>19,500,000원</td>
											<td>50kw</td>
											<td>2채널</td>
										</tr>
										<tr>
											<td>25967318</td>
											<td>GKCD100PS-HC27L5G</td>
											<td>27,600,000원</td>
											<td>100kW</td>
											<td>1채널</td>
										</tr>
										<tr>
											<td>25965784</td>
											<td>GKCD100P-HC27L5G</td>
											<td>28,000,000원</td>
											<td>100kW</td>
											<td>2채널</td>
										</tr>
										<tr>
											<td>25800825</td>
											<td>GKCD200P-C27L5G</td>
											<td>35,000,000원</td>
											<td>200kW</td>
											<td>2채널</td>
										</tr>
										<tr>
											<td>26243606</td>
											<td>GKCD50PS-G2-H15MWC</td>
											<td style={{ textAlign: "center" }}><span className={styles.quarter_transparent}>가격협상중</span></td>
											<td>50kW</td>
											<td>1채널, 15인치</td>
										</tr>
										<tr>
											<td>26237410</td>
											<td>GKCD50P-G2-H15MWC</td>
											<td style={{ textAlign: "center" }}><span className={styles.quarter_transparent}>가격협상중</span></td>
											<td>50kW</td>
											<td>2채널, 15인치</td>
										</tr>
										<tr>
											<td>26237408</td>
											<td>GKCD100PS2-HC27L5G</td>
											<td style={{ textAlign: "center" }}><span className={styles.quarter_transparent}>가격협상중</span></td>
											<td>100kw</td>
											<td>1채널</td>
										</tr>
										<tr>
											<td>26237409</td>
											<td>GKCD100P2-HC27L5G</td>
											<td style={{ textAlign: "center" }}><span className={styles.quarter_transparent}>가격협상중</span></td>
											<td>100kw</td>
											<td>2채널</td>
										</tr>
										<tr>
											<td>26243607</td>
											<td>GKCD200P2-C27L5G</td>
											<td style={{ textAlign: "center" }}><span className={styles.quarter_transparent}>가격협상중</span></td>
											<td>200kW</td>
											<td>2채널</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				<div id={"KCA7P7PG"} style={{ marginBottom: "100px" }}>
					<CSFDSSection1 g={true} />
				</div>
				<div className={styles.KCA7Series} id="KCA7Series">
					<h4 className={styles.h4} data-aos="fade-down" data-aos-offset="300">
						GKCA7
						<div>series</div>
					</h4>

					<div className={styles.KCA11Series_bg} data-aos="fade-down"></div>

					<div className={styles.KCA7Series_content_1} data-aos="fade-down">
						<div className={styles.KCA7Series_stand}>
							<div><img alt="이미지02-04" src="/images/02-04.png" /></div>
							<div><img alt="이미지02-05" src="/images/02-05.png" /></div>
						</div>

						<div className={styles.KCA7Series_stand_txt}>
							<ul className={styles.KCA7}>
								<li>
									GKCA7N
								</li>

								<li>
									{t("비공용 완속 충전기")}
								</li>

								<li></li>
							</ul>

							<ul className={styles.KCA7P}>
								<li>
									GKCA7P
								</li>

								<li>
									{t("공용 완속 충전기")}
								</li>

								<li></li>
							</ul>
						</div>

						<div className={styles.KCA7Series_place}>
							<div className={styles.KCA7_place + " " + styles.KCA7_place_extended} data-aos="fade-down">
								<img alt="이미지02-06" src="/images/02-06.png" />

								<ul>
									<li>
										<span>GKCAN7PG-L5G</span>, <span>GKCAN7PG-CL5G</span>는 PLC  모뎀 탑재 화재예방형 스마트 충전기는 <span>7KW</span> 용량으로 개인 주택 및 사무실에 설치하여 언제든지 원하는 대로 충전할 수 있는 모델입니다.
									</li>

									<li>
										<span className={styles.txt_span}>▪</span> 충전 중 배터리 상태정보(전압, 전류, 온도, SoC 등) 수집하여 CSMS에 전송, 충전 제어 정보를 수신하여 실시간 충전 제어
									</li>

									<li>
										<span className={styles.txt_span}>▪</span> {t("충전 상태 표시 LED (대기/충전/완료/오류)")}
									</li>

									<li>
										<span className={styles.txt_span}>▪</span> {t("단독, 다가구, 공동주택 및 사업장 등의 비과금형 충전용")}
									</li>

									<li>
										<span className={styles.txt_span}>▪</span> {t("RF 태그를 이용한 사용자 인증")}
									</li>
								</ul>
							</div>

							<div className={styles.KCA7_place + " " + styles.KCA7_place_extended} data-aos="fade-down" data-aos-delay="200">
								<img alt="이미지02-07" src="/images/02-07.png" />

								<ul>
									<li>
										<span>GKCAP7PG-L5G</span>, <span>GKCAP7PG-CL5G</span> 충전기는 <span>7kW</span> 용량으로 사업장, 공용주차장, 쇼핑몰등에 설치하여 수익 사업이 가능한 모델입니다. (카메라 옵션 선택 가능)
									</li>

									<li>
										<span className={styles.txt_span}>▪</span> {t("충전 상태 표시 디스플레이 (8” 컬러 LCD)")}
									</li>

									<li>
										<span className={styles.txt_span}>▪</span> {t("다양한 결제 방식 지원 (멤버십카드, 페이온 후불교통카드, 삼성페이)")}
									</li>

									{/*<li>*/}
									{/*    <span className={styles.txt_span}>▪</span> AI 자동차 번호 인식 기반 자동 충전 기능 (option)*/}
									{/*</li>*/}
								</ul>
							</div>

						</div>
					</div>

					<div className={styles.KCA7Series_content_2} data-aos="fade-up">
						<div className={styles.content_2_set}>
							<div><img alt="이미지02-set-01" src="/images/02-set-01.png" /></div>
							<div><img alt="이미지02-set-02" src="/images/02-set-02.png" /></div>
							<div><img alt="이미지02-set-03" src="/images/02-set-03.png" /></div>
						</div>

						<div className={styles.KCA7Series_table}>
							<table>
								<tbody>
								<tr>
									<th>{t("모델명")}</th>
									<td>KCA7, KCA7P</td>
								</tr>

								<tr>
									<th>{t("입력")}</th>
									<td>1Ø 2W, 220V AC, 60Hz 32A</td>
								</tr>

								<tr>
									<th>{t("출력")}</th>
									<td>1Ø 2W, 220V AC, 60Hz 7kW</td>
								</tr>

								<tr>
									<th>{t("인증방식")}</th>
									<td>{t("RF CARD 및 신용카드 결재")}</td>
								</tr>

								<tr>
									<th>{t("충전시간")}</th>
									<td>{t("10시간 이내 (64kWh기준)")}</td>
								</tr>

								<tr>
									<th>{t("크기")}</th>
									<td>264(W) x 408(H) x 97.5(D)mm</td>
								</tr>

								<tr>
									<th>PLC MODEM</th>
									<td>QCA7006, Qualcomm HPGP, 9.8Mbps</td>
								</tr>

								<tr>
									<th>{t("인렛 구조")}</th>
									<td>SAE J1772 Type1, 16.8 Ø</td>
								</tr>

								<tr>
									<th>{t("충전 차량")}</th>
									<td>{t("표준 5PIN 차량")}</td>
								</tr>

								<tr>
									<th>{t("인증")}</th>
									<td>{t("KC / 형식승인 / OCPP 1.6 인증")}</td>
								</tr>

								<tr>
									<th>{t("IP등급")}</th>
									<td>{t("본체 : IP65 / 커플러 : IP68")}</td>
								</tr>

								<tr>
									<th>{t("설치방식")}</th>
									<td>{t("월박스 및 스탠드 모두 가능")}</td>
								</tr>
								</tbody>
							</table>
						</div>

						<div className={styles.content_2_set}>
							<div><img alt="이미지02-set-04" src="/images/02-set-04.png" /></div>
							<div><img alt="이미지02-set-05" src="/images/02-set-05.png" /></div>
							<div><img alt="이미지02-set-06" src="/images/02-set-06.png" /></div>
						</div>
					</div>
				</div>

				<div className={styles.KCD50100} id="KCD50100">
					<h4 className={styles.h4} data-aos="fade-down">
						GKCD<br/>
						50/100
					</h4>

					<div className={styles.KCD50100_bg} data-aos="fade-down"></div>

					<div className={styles.KCD50100_content_1} data-aos="fade-down">
						<div className={styles.KCD50100_stand}>
							<div><img alt="이미지02-17" src="/images/device/50kW_KOOL_CHARGE_231020.139.png" /></div>
							<div><img alt="이미지02-17" src="/images/device/50kW_KOOL_CHARGE_231020.141.png" /></div>
						</div>

						<div className={styles.KCD50100_stand_txt}>
							<ul className={styles.KCD50100_nm}>
								<li>
									GKCD50/100
								</li>

								<li></li>

								<li>
									{t("급속 충전기")}
								</li>
							</ul>
						</div>

						<div className={styles.KCD50100_place}>
							<div className={styles.KCD50100_place_inner} data-aos="fade-down">
								<img alt="이미지02-18" src="/images/02-18.jpg" />

								<ul>
									<li>
										<span>GKCD50PS-C27L5G, GKCD50PS-C27L5G</span> 충전기는 <span>50kW</span> 용량의 급속 1/2채널 충전기로 전용 충전소, 사옥, 주차장, 백화점, 대형 마트, 쇼핑몰 등 모든 장소에 설치 가능한 모델입니다.
									</li>

									<li>
										<span className={styles.txt_span}>▪</span> {t("충전 상태 및 광고 디스플레이 (27” 터치스크린)")}
									</li>

									<li>
										<span className={styles.txt_span}>▪</span> {t("충전기 동작상태 음성 안내 스피커")}
									</li>

									<li>
										<span className={styles.txt_span}>▪</span> {t("2채널 스마트 충전")}
									</li>

									<li>
										<span className={styles.txt_span}>▪</span> {t("AI기반 자동차 번호 인식 및 화재 감시 기능")}
									</li>

									<li>
										<span className={styles.txt_span}>▪</span> {t("다양한 결제 방식 지원 (멤버십카드, 신용카드, 삼성페이)")}
									</li>
								</ul>
							</div>
						</div>
					</div>

					<div className={styles.KCA7Series_content_2} data-aos="fade-up">
						<div className={styles.content_2_set}>
							<div><img alt="이미지02-set-19" src="/images/02-set-19.png" /></div>
							<div><img alt="이미지02-set-20" src="/images/02-set-20.png" /></div>
							<div><img alt="이미지02-set-21" src="/images/02-set-21.png" /></div>
						</div>

						<div className={styles.KCA7Series_table}>
							<table>
								<tbody>
								<tr>
									<th>{t("모델명")}</th>
									<td>GKCD50</td>
									<td>GKCD100</td>
								</tr>

								<tr>
									<th>{t("입력")}</th>
									<td>3Ø 4W, 380V AC, 60Hz, 50kW</td>
									<td>3Ø 4W, 380V AC, 60Hz, 100kW</td>
								</tr>

								<tr>
									<th>{t("출력")}</th>
									<td>
										{t("1CH 충전")}<br/>DC 150~1000V, Max.150A, 50kW<br/>
										{t("2CH 동시 충전")}<br/>DC 150~1000V, Max.150A, 25kW x 2
									</td>
									<td>
										{t("1CH 충전")}<br/>DC 150~1000V, Max.200A, 100kW<br/>
										{t("2CH 동시 충전")}<br/>DC 150~1000V, Max.200A, 50kW x 2
									</td>
								</tr>

								<tr>
									<th>{t("인증방식")}</th>
									<td colSpan={2}>{t("RF CARD 및 신용카드 결재")}</td>
								</tr>

								<tr>
									<th>{t("효율 / 역율")}</th>
									<td colSpan={2}>{t("95% 이상 / 0.95 이상")}</td>
								</tr>

								<tr>
									<th>{t("크기")}</th>
									<td>780(W) x 1600(H) x 400(D)mm</td>
									<td>780(W) x 1800(H) x 400(D)mm</td>
								</tr>

								<tr>
									<th>{t("인렛 구조")}</th>
									<td colSpan={2}>CCS Type 1</td>
								</tr>

								<tr>
									<th>{t("충전 차량")}</th>
									<td colSpan={2}>{t("표준 5PIN 차량")}</td>
								</tr>

								<tr>
									<th>{t("인증")}</th>
									<td colSpan={2}>{t("KC / 형식승인 / OCPP 1.6 인증")}</td>
								</tr>

								<tr>
									<th>{t("IP등급")}</th>
									<td colSpan={2}>{t("본체 : IP44 / 커플러 : IP54")}</td>
								</tr>

								<tr>
									<th>{t("통신방식")}</th>
									<td colSpan={2}>4G LTE Cat 4</td>
								</tr>

								<tr>
									<th>{t("차단기 용량")}</th>
									<td>{t("누전차단기 100A , 30mA")}</td>
									<td>{t("누전차단기 200A , 30mA")}</td>
								</tr>
								</tbody>
							</table>
						</div>

						<div className={styles.content_2_set}>
							<div><img alt="이미지02-set-22" src="/images/02-set-22.png" /></div>
							<div><img alt="이미지02-set-23" src="/images/02-set-23.png" /></div>
							<div><img alt="이미지02-set-24" src="/images/02-set-24.png" /></div>
						</div>
					</div>
				</div>

				<Device200240 g={true}/>
			</section>
		</div>
	);

}

export default PublicMain;
